import React from "react";
import PropTypes from "prop-types";
import { Grid, CircularProgress } from "@material-ui/core";
import NumericDataBlock from "../../../../../../app/components/NumericDataBlock";
import { translate as t } from "../../../../../../infrastructure/translate/localization";
import LineChartBlock from "../../../../../../app/components/LineChartBlock";
import AdhesionRateChartTooltip from "../AdhesionRateChartTooltip";
import useStyles from "./styles";

export default function AdhesionBlock({
  adhesionData,
  loadedEmployeesData,
  activeEmployeesData,
  adhesionRateData,
  isLoading,
}) {
  const { chartContainer, spinner } = useStyles();

  return (
    <Grid item container xs={12} direction="column">
      <Grid container direction="row" spacing={5}>
        <Grid item xs={4}>
          <NumericDataBlock
            isLoading={isLoading}
            title={t("analytics-section.adhesion-rate")}
            {...adhesionData}
          />
        </Grid>
        <Grid item xs={4}>
          <NumericDataBlock
            isLoading={isLoading}
            title={t("analytics-section.loaded-employees")}
            {...loadedEmployeesData}
          />
        </Grid>
        <Grid item xs={4}>
          <NumericDataBlock
            isLoading={isLoading}
            title={t("analytics-section.active-employees")}
            {...activeEmployeesData}
          />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        container
        className={(adhesionRateData?.data || isLoading) && chartContainer}
        justify="center"
        alignItems="center"
      >
        {isLoading ? (
          <CircularProgress className={spinner} />
        ) : (
          <LineChartBlock
            data={adhesionRateData?.data}
            LabelComponent={AdhesionRateChartTooltip}
          />
        )}
      </Grid>
    </Grid>
  );
}

AdhesionBlock.defaultProps = {
  adhesionData: {},
  loadedEmployeesData: {},
  activeEmployeesData: {},
  adhesionRateData: undefined,
  isLoading: false,
};

AdhesionBlock.propTypes = {
  adhesionData: PropTypes.object,
  loadedEmployeesData: PropTypes.object,
  activeEmployeesData: PropTypes.object,
  adhesionRateData: PropTypes.object,
  isLoading: PropTypes.bool,
};
